import React, { useContext, useEffect, useRef, useState } from 'react';
import { LoginContext } from '../../../App';
import { fetchQualitativeTypeData, fetchQualitativeTypesData, getQualTypesCSV, importingQualTypesCSVFile } from '../../../services/b2b-indicators-apiService';
import { DeveloperBoard, Download } from '@mui/icons-material';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';
import B2BDialog from '../../b2b-common/B2BDialog';
import { callAPIWhileSettingState, fetchAPIDataWhileSettingState, get_YYMMDDHHMM } from '../../b2b-common/helpers';
import QualTypeModal from '../modal/QualTypeModal';

import './QualitativeTypesTable.css';

const QualitativeTypesTable = () => {

    const { loginData } = useContext(LoginContext);
    const [qualitativeTypes, setQualitativeTypes] = useState(null);
    const [refreshTable, setRefreshTable] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const getQualitativeTypes = async () => {
            try {
                const { accessToken } = loginData;
                const data = await fetchQualitativeTypesData(accessToken);
                setQualitativeTypes(data);
            } catch (error) {
                setError(error.message);
            }
        };

        getQualitativeTypes();
    }, [loginData, refreshTable]);

    // TABLE

    const headers = [
        { label: 'Name', align: 'left' },
        { label: 'Description', align: 'left' },
        { label: 'Inds #', align: 'center' },
    ];

    const rows = qualitativeTypes ? qualitativeTypes.map((type) => ({
        id: type.qualitativeTypeId,
        cells: [
            { content: `${type.qualitativeTypeName_label}`, align: 'left' },
            { content: `${type.qualitativeTypeDescription_label}`, align: 'left' },
            { content: `${type.indicatorsCount}`, align: 'center' },
        ]
    })) : [];

    // Downloading CSV

    const [downloadingCSV, setDownloadingCSV] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogError, setDialogError] = useState(null);

    const handleDownloadingCSV = async () => {
        const fileName = 'b2b-qualitative-types-' + get_YYMMDDHHMM() + '.csv';
        const paramsArray = [
            loginData.accessToken,
            ';',
            fileName
        ];
        try {
            await callAPIWhileSettingState(getQualTypesCSV, paramsArray,
                setDownloadingCSV, null);
        } catch (error) {
            setDialogOpen(true);
            setDialogError('Failed to download csv: ' + error.message);
        } finally {
            setDownloadingCSV(false);
        }
    }

    // Importing CSV

    const csvFileInputRef = useRef(null);
    const [processingCSVFile, setProcessingCSVFile] = useState(false);

    const handleUploadingCSV = () => {
        csvFileInputRef.current.click();
    }

    const handleCSVFileUpload = async (e) => {
        const paramsArray = [
            e.target.files[0],
            ';',
            loginData.accessToken
        ];
        try {
            await callAPIWhileSettingState(importingQualTypesCSVFile, paramsArray,
                setProcessingCSVFile, onCSVImported);
            setRefreshTable(prev => !prev);
        } catch (error) {
            setDialogOpen(true);
            setDialogError('Failed to import csv: ' + error.message);
        } finally {
            e.target.value = null;
        }
    }

    const onCSVImported = () => {
        setDialogOpen(true);
        setDialogError(null);
    }

    // MODAL

    const [openQualTypeModal, setOpenQualTypeModal] = useState(false);
    const [selectedQualType, setSelectedQualType] = useState(null);

    const handleSelectQualType = (rowId) => {
        console.log('Selected Qual Type:', rowId);
        setSelectedQualType(rowId.id);
        setOpenQualTypeModal(true);
    }

    const buttons = [
        {
            label: 'New Type',
            disabledText: 'New Type',
            onClick: () => setOpenQualTypeModal(true),
            color: 'secondary',
            variant: 'contained',
            key: '1',
            icon: <DeveloperBoard />,
        },
        {
            label: 'Get CSV',
            disabledText: 'Get CSV',
            onClick: null,
            color: 'secondary',
            variant: 'contained',
            key: '2',
            icon: <Download />,
        },
    ]

    return (
        <>
            <B2BTableInMemory
                headers={headers}
                rows={rows}
                className={"qualitative-types-list-table"}
                numRows={10}
                stickyHeader={false}
                onRowClick={(id) => handleSelectQualType(id)}
                buttons={buttons}
            />
            <input
                ref={csvFileInputRef}
                type="file"
                style={{ display: 'none' }}
                onChange={handleCSVFileUpload}
            />
            <QualTypeModal
                open={openQualTypeModal}
                toChangeQualTypeId={selectedQualType}
                onClose={() => {
                    setOpenQualTypeModal(false);
                    setSelectedQualType(null);
                }}
                onUpdate={() => setRefreshTable(prev => !prev)}
            />
            <B2BDialog
                open={false}
                onClose={() => {
                    setDialogOpen(false);
                    setDialogError(null);
                }}
                title={dialogError ? 'Error downloading CSV' : 'CSV Downloaded'}
            >
                <p>{dialogError || "The csv file has been downloaded successfully."}</p>
            </B2BDialog>

        </>
    );
};

export default QualitativeTypesTable;